import { useCallback, useEffect, useState } from "react";
import { useApi } from "../contexts/ApiProvider";
import useDialog from "../contexts/DialogProvider";
import { TRequestQuery } from "../api/HomaticApiClient";
import useIsVisible from "./useIsVisible";
import { useTranslation } from "react-i18next";

const useFetchData = <T>(url: string, query?: TRequestQuery) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<T>();
  const showDialog = useDialog();
  const api = useApi();
  const isVisible = useIsVisible();
  const { t } = useTranslation();

  const fetch = useCallback(async () => {
    setIsLoading(true);
    const response = await api.get<T>(url, query);
    setIsLoading(false);
    if (response.ok && response.body) {
      setData(response.body as T);
    } else {
      showDialog({
        title: t("Request failed"),
        text: t("Please, try again."),
      });
    }
  }, [url, query, api, showDialog, t]);

  useEffect(() => {
    if (isVisible) {
      fetch();
    }
  }, [isVisible, fetch]);

  return { data, isLoading };
};

export default useFetchData;
